<template>
    <b-container fluid class="mt--7">
        <list-items v-if="isList" title="Warehouse Inventory" ref="table">
            <b-button-group class="float-right">
                <b-button
                    variant="secondary"
                    @click="exportMasterItems()"
                    v-if="hasPermissionView"
                >
                    <b-spinner small v-if="loading"></b-spinner>
                    <span v-else> Export</span>
                </b-button>
               
            </b-button-group>
        </list-items>
    </b-container>
</template>
<script>
import ListItems from './ListItems'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

import showItemHelper from '@/mixins/showItemHelper'

export default {
    name: 'SectionItems',
    components: {
        ListItems,
    },
    mixins: [popupMixins, showItemHelper, permissionsMixins],
    data: () => {
        return {
            item: null,
            loading: false,
        }
    },
    created() {},
    computed: {},

    methods: {
        alertSuccess(message) {
            this.doToast('Success', message, 'success')
        },
        exportMasterItems() {
            this.$refs.table.generateReport()
        },
    },
}
</script>
<style></style>
